module.exports = __webpack_public_path__ + "img/rib-eye.569e67df.jpg";